import React, {useRef, useState} from "react";
import dynamic from 'next/dynamic';
import classNames from "classnames";
import {settings} from "../../constants/carousel-settings";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import Icon from "../baseComponents/gui/icon/Icon";
import CurrentCirculationsItem from "./CurrentCirculationsItem";
import styles from "./CurrentCirculations.module.scss";
const Carousel = dynamic(() => import('../baseComponents/gui/carousel/Carousel'), { ssr: false });


const CurrentCirculations = React.forwardRef(
  function CurrentCirculations(props, ref) {
    const {className,list:listData} = props;
    const [carouselStatus, setCarouselStatus] = useState("start");
    const list = listData || []
    const nextElRef = useRef(null);
    const prevElRef = useRef(null);

    return (
      <div className={classNames(styles.currentCirculations,className,{
        [styles[`currentCirculations_${carouselStatus}`]]:carouselStatus
      })} ref={ref}>
        <div className={styles.currentCirculations__content}>

          <Carousel itemsData={list}
                    item={CurrentCirculationsItem}
                    settings={{
                      ...settings.games,
                      navigation:{
                        nextEl: ".navBtnNext",
                        prevEl: ".navBtnPrev",
                      },
                      onReachEnd:()=>{
                        list.length > 4 &&  setCarouselStatus("end")
                      },
                      onReachBeginning:()=>{
                        list.length > 4 &&   setCarouselStatus("start")
                      },
                      onSlideChange:({isBeginning, isEnd})=>{
                        if (!isBeginning &&  !isEnd ){
                          setCarouselStatus("")
                        }
                      }
                    }}
          />
          <div className={styles.currentCirculations__navigation}>
            <Button className={classNames(
              buttonStyles.button_white,
              buttonStyles.button_icon,
              styles.currentCirculations__navButton,
              "navBtnPrev"
            )}
              ref={prevElRef}
              aria-label={"назад"}
              title={"назад"}
            >
              <Icon name={"prev"} width={56} height={56}/>
            </Button>
            <Button className={classNames(
              buttonStyles.button_white,
              buttonStyles.button_icon,
              styles.currentCirculations__navButton,
              "navBtnNext"
            )}
              ref={nextElRef}
              aria-label={"вперед"}
              title={"вперед"}
            >
              <Icon name={"next"} width={56} height={56}/>
            </Button>
          </div>
        </div>
      </div>
    );
  });
export default CurrentCirculations;
CurrentCirculations.propTypes = {};

